import { webviewJsObjectName } from "../is-in-android";
import { callScriptMockDataMap } from "./call-script-mock-data-map";

function createMap(){
    const map = {
        documentIsReady:false,
        reload:()=>{
            window.location.reload()
        },
        onDocumentReady:()=>{
            map.documentIsReady = true;
        },
        onJsCallEvent:(type:string, value:string)=>{
            console.log('onJsCallEvent', type, value)
        },
        dispatchData:(targetName:string, eventType:string, data:string)=>{
            console.log('dispatchData', targetName, eventType, data)
        },
        callExitFromJs:()=>{
            console.log('callExitFromJs')
        },
        onCallGetA11yPermission:()=>{
            return {
                javaResultData:true
            }
        },
        onCallOpenA11yPermission:()=>{
            console.log('onCallOpenA11yPermission')
        },
        callScript:<T>(script:string)=>{
            const mockData = callScriptMockDataMap[script]
            if(mockData){
                return mockData.fn ? mockData.fn(script) : mockData.result
            }
            return ''
        },
        isFake:true
    }
    return map;
}

export function mockWebView(){
    if(typeof window === 'undefined')return;
    (window as any)[webviewJsObjectName] = createMap();
}